<template>
    <div>
        <template v-if="product">
            <div>
                <div class="flex items-center mb-24">
                    <div class="w-64 h-64">
                        <img :src="product.logo_square_url" :alt="`${product.name}-logo`">
                    </div>
                    <div class="flex flex-col ml-24">
                        <p class="text-heading-1 font-semibold mb">{{ product.name }}</p>
                        <div class="flex">
                            <p>{{ duration }}</p>
                            <p class="ml-16">{{ price }}</p>
                            <a :href="product.url" target="_blank" class="ml-16">{{ product.url }}</a>
                        </div>
                    </div>
                </div>
                <p>{{ product.description }}</p>
            </div>
            <div class="border-t mt-24 mb-16"></div>
            <div>
                <div class="flex">
                    <div class="min-w-140 mr-24 my-16">
                        <label class="text-body font-semibold">{{ $t('multi-posting.job-boards.processing_time') }}</label>
                        <p>{{ processingTime }}</p>
                    </div>
                    <div class="min-w-140 mr-24 my-16">
                        <label class="text-body font-semibold">{{ $t('multi-posting.form.duration') }}</label>
                        <p>{{ duration }}</p>
                    </div>
                    <div class="min-w-140 mr-24 my-16">
                        <label class="text-body font-semibold">{{ $t('general.price') }}</label>
                        <p>{{ price }}</p>
                    </div>
                </div>
                <div class="flex">
                    <div class="min-w-140 mr-24 my-16">
                        <label class="text-body font-semibold">{{ $t('general.locations.title') }}</label>
                        <div class="flex">
                            <p v-for="location in product.locations" class="mr-16">{{location.canonical_name}}</p>
                        </div>
                    </div>
                    <div class="min-w-140 mr-24 my-16">
                        <label class="text-body font-semibold">{{ $t('multi-posting.campaigns.filters.industries') }}</label>
                        <div class="flex">
                            <p v-for="location in product.industries" class="mr-16">{{location.name}}</p>
                        </div>
                    </div>
                </div>
                <div class="flex justify-end">
                    <simple-button
                        v-if="isSelectedItem(product)"
                        display="danger"
                        @click="removeFromCampaign(product)"
                    >
                        {{ $t('multi-posting.campaigns.form.remove_from_campaign') }}
                    </simple-button>
                    <simple-button
                        v-else
                        display="primary"
                        @click="addToCampaign(product)"
                    >
                        {{ $t('multi-posting.contracts.index.add_to_campaign') }}
                    </simple-button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import SimpleButton from "../ui/SimpleButton.vue";
import {mapActions, mapState} from "pinia";
import {useMultiPostingStore} from '../../state/modules/multiPosting';

export default {
    name: 'CampaignDetails',
    components: {SimpleButton},
    props: {
        product: {type: Object, required: true}
    },
    computed: {
        ...mapState(useMultiPostingStore, ['selectedItems']),
        processingTime() {
            let range, time;
            if (this.product.time_to_process > 24) {
                // convert hours to days
                time = Math.floor(this.product.time_to_process / 24);
                range = this.$tc('general.working_days', time);
            } else {
                time = this.product.time_to_process;
                range = this.$tc('general.hours', time);
            }
            return `${time} ${range}`;
        },
        duration() {
            return `${this.product.duration.period} ${this.product.duration.range}`;
        },
        price() {
            return (this.product.vonq_price[0].amount === 0)
                ? this.$t('multi-posting.price.free')
                : `${this.product.vonq_price[0].amount} ${this.product.vonq_price[0].currency}`;
        },
    },
    methods: {
        ...mapActions(useMultiPostingStore, ['removeSelectedItemById', 'addSelectedItems']),
        addToCampaign(product) {
            this.addSelectedItems([{
                id: product.id,
                channel_id: product.channel_id,
                name: product.name,
                price: {
                    amount: product.vonq_price[0].amount,
                    currency: product.vonq_price[0].currency
                },
                duration: product.duration,
                type: 'product',
                logo_square_url: product.logo_square_url,
                time_to_process: product.time_to_process,
                time_to_setup: product.time_to_setup
            }]);
            this.$emit('added');
        },
        isSelectedItem(product) {
            return this.selectedItems.filter(x => x.id === product.id).length > 0;
        },
        removeFromCampaign(product) {
            this.removeSelectedItemById({itemId: product.id});
        },
    },
}
</script>
